export default __webpack_public_path__ + "static/media/nebula.5b22ca1a.svg";